import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitRecurringPaymentFormGroup } from '../../../../../records/components/members/ip-view-member-record/components/ip-member-record-variable-benefit-configuration/form-groups/variable-benefit-recurring-payment-form-group';

@Component({
  selector: 'app-variable-benefit-recurring-payment-details',
  templateUrl: './variable-benefit-recurring-payment-details.component.html',
  styleUrls: ['./variable-benefit-recurring-payment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitRecurringPaymentDetailsComponent {
  @Input() monthlyRecurringPaymentForm!: VariableBenefitRecurringPaymentFormGroup;
  @Input() annualRecurringPaymentForm!: VariableBenefitRecurringPaymentFormGroup;
  @Input() isMandatoryRetirement!: boolean;
  @Input() isMemberPortal = false;
}
